import { useState } from 'react'
import axios from 'axios'
import { message, Modal } from 'antd'

const Forms = (props) => {
  const [formValue, setFormValue] = useState({})

  const handleOk = () => {
    axios.post('/c/kf_c/consultant/edit', {
        user_oid: props.data.userId,
        realname: formValue.realname,
      })
      .then(function (response) {
        if (response.errcode === 0) {
          props.isCancel()
        } else {
          message.warning(response.msg)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  return (
    <Modal 
      destroyOnClose={true}
      width='300px'
      open={props.isOpen}
      closable={false}
      maskClosable={false}
      keyboard={false}
      footer=''>

      <div className='forms-title'>完善个人信息</div>

      <input
        className='forms-input'
        type="text" 
        id='realname' 
        placeholder='请输入姓名'
        value={formValue.realname}
        onChange={(e) => setFormValue(prevValues => ({ ...prevValues, realname: e.target.value }))}
      />

      <div className='forms-submit-box'>
        <div className='forms-submit' onClick={handleOk}>保存</div>
      </div>
      </Modal>
  )
}

export default Forms
